import { Injectable, EventEmitter } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable ,  Subject } from 'rxjs';

import { Alert, AlertType } from '../classes/alert';
import { Bureau } from '../../core/shared/classes/bureau';
import { Batiment } from '../../infrastructure/shared/classes/batiment';
import { Identifiers } from '@angular/compiler';
import { Identite } from '../../identite/shared/classes/identite';
import { Role } from '../../identite/shared/classes/role';

@Injectable()
export class EventService {

    public logoEvent: EventEmitter<any>;
    public bureauxEvent: EventEmitter<any>;
    public maitresEvent: EventEmitter<any>;
    public batimentsEvent: EventEmitter<any>;
    public prospectEvent: EventEmitter<any>;
    public lotEvent: EventEmitter<any>;
    public reloadBureauxEvent: EventEmitter<any>;
    public actionDocumentModal: EventEmitter<any>;

    constructor(private router: Router) {
        this.logoEvent    = new EventEmitter();
        this.bureauxEvent = new EventEmitter();
        this.maitresEvent = new EventEmitter();
        this.batimentsEvent = new EventEmitter();
        this.prospectEvent = new EventEmitter();
        this.lotEvent = new EventEmitter();
        this.actionDocumentModal = new EventEmitter();
        this.reloadBureauxEvent = new EventEmitter();
    }


    emitLogoEvent() {
        this.logoEvent.emit('reload logo');
    }

    emitBureauxEvent(bureaux: Bureau[]) {
        this.bureauxEvent.emit(bureaux);
    }

    emitMaitreEvent(maitres: Role[]) {
        this.maitresEvent.emit(maitres);
    }

    emitBatimentEvent(batiments: Batiment[]) {
        this.batimentsEvent.emit(batiments);
    }

    emitNewProspectEvent(prospect: any) {
        this.prospectEvent.emit(prospect);
    }

    emitNewLotEvent(lot: any) {
        this.lotEvent.emit(lot);
    }

    emitReloadBureauxEvent() {
        this.reloadBureauxEvent.emit();
    }
    emitNewActionDocumentModalEvent(pdf: any) {
        this.actionDocumentModal.emit(pdf);
    }
}
